module.exports = __webpack_public_path__ + "static/media/ico-help.6414190e.svg";